import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import classNames from 'classnames'

import { Config } from '../constants'
import { LanguageContext} from '../contexts'
import { fillTemplateString } from '../utility'

import logoCanada from './logo-Canada.png'
import logoOntario from './logo-Ontario.png'

import './Footer.scss'

export function Footer() {
	const { localizedText, language } = useContext(LanguageContext)

	const footerClassName = classNames('footer', Config.Environment)

	return (
		<footer className={footerClassName}>
			<div className='level'>
				<div className='level-left'>
					<div className='level-item'>
						<img src={logoOntario} className='header-logo' alt="Ontario" title="ontario" />
					</div>
				</div>

				<div className='level-item has-text-centered'>
					{fillTemplateString(localizedText.CopyrightNoticeTemplate, { year: new Date().getFullYear() })}
				</div>

				<div className='level-right'>
					<div className='level-item'>
						<img src={logoCanada} className='header-logo' alt="Canada" title="Canada" />
					</div>
				</div>
			</div>
			<div className='content has-text-centered'>
				<span className={`environment-display is-size-7 ${Config.Environment}`}>{Config.EnvironmentDisplay}</span>
			</div>
		</footer>
	)
}